/* components/patterns/kitchen/KitchenToolbar.jsx — тулбар реестра Кухни.
   Поиск (debounce в URL) + «Фильтры» (бейдж активных) + SortMenu + кнопка действия.
   На xs/sm — компактный режим (иконки без подписей, поиск на всю строку).
   Переиспользует общие примитивы S1: SearchInput, Button, SortMenu (без дублей).
   ХЕНДОФФ → frontend/components/kitchen/KitchenToolbar.jsx. */

import { SortMenu } from '../DataTable.jsx';
import { Button } from '../../ui/Button.jsx';
import { SearchInput } from '../../ui/Field.jsx';
import { Icon } from '../../ui/Icon.jsx';
import { hooks } from '../../../hooks/index.jsx';

  const { useBreakpoint } = hooks;

  function KitchenToolbar({
    search, onSearch, searchPlaceholder = 'Поиск…',
    onFilter, activeFilterCount = 0,
    sortOptions, sortValue, onSort,
    actionLabel, actionIcon = 'plus', onAction,
  }) {
    const { bp } = useBreakpoint();
    const compact = bp === 'xs' || bp === 'sm';

    return (
      <div className="kt-toolbar">
        <div className="kt-toolbar__search">
          <SearchInput value={search} onChange={onSearch} placeholder={searchPlaceholder} />
        </div>
        <div className="kt-toolbar__controls cluster cluster-6">
          {onFilter && (
            <button type="button" className={'kt-filter-btn' + (activeFilterCount ? ' is-active' : '')}
              onClick={onFilter} aria-label="Фильтры">
              <Icon name="filter" size={16} />
              {!compact && <span className="kt-filter-btn__label">Фильтры</span>}
              {activeFilterCount > 0 && <span className="kt-filter-btn__count num">{activeFilterCount}</span>}
            </button>
          )}
          {sortOptions && sortOptions.length > 0 && (
            <SortMenu options={sortOptions} value={sortValue} onChange={onSort} />
          )}
          {onAction && (
            <Button variant="primary" size="md" iconLeft={actionIcon}
              iconOnly={compact ? actionIcon : undefined}
              onClick={onAction} aria-label={actionLabel}>
              {!compact ? actionLabel : null}
            </Button>
          )}
        </div>
      </div>
    );
  }

export { KitchenToolbar };
